import { attr } from '@ember-data/model';
import ShModel from './sh-model';

class GhostBlogModel extends ShModel {
  @attr('string') excerpt;
  @attr('string') featureImage;
  @attr('string') featureImageCaption;
  @attr('date') publishedAt;
  @attr('number') readingTime;
  @attr('string') slug;
  @attr('string') title;
  @attr('string') url;
}

export default GhostBlogModel;
